/*
 *   File : protected-route.js
 *   Author : https://evoqins.com
 *   Description : protected route component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function ProtectedRoute({ children }) {
  const token = Cookies.get("access_token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
